import React from 'react';
import { motion } from 'framer-motion';
interface CtaButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}
export function CtaButton({
  children,
  onClick,
  className = ''
}: CtaButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', 'AddToCart', {
          content_name: 'Menopausia Sin Tabú',
          content_type: 'product',
          value: 6.39,
          currency: 'USD'
        });
      }
      window.open('https://www.plenavital.com/cart/48149146566881:1', '_blank');
    }
  };
  return <motion.button whileHover={{
    scale: 1.02,
    boxShadow: '0 10px 25px -5px rgba(160, 82, 45, 0.4)'
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`bg-brand-terracotta text-white font-bold py-4 px-8 rounded-full shadow-lg text-lg md:text-xl w-full max-w-md mx-auto block transition-colors hover:bg-[#8a4524] ${className}`} data-id="element-13">
      {children}
    </motion.button>;
}